if (!customElements.get('product-energy-label')) {
  customElements.define(
    'product-energy-label',
    class ProductEnergyLabel extends HTMLElement {
      constructor() {
        super();
        this.imageUrl = this.getAttribute('data-product-energy-label-image');
        this.tooltip = this.querySelector('.eu-energy-label__tooltip');
        this.trigger = this.querySelector('.eu-energy-label__content');
        this.loaded = false;
        this.reposition = this.positionTooltip.bind(this);

        if (this.imageUrl && this.tooltip && this.trigger) {
          // Move the tooltip to the body so it can't be clipped by an
          // ancestor with `overflow: hidden` (e.g. the product info box).
          document.body.appendChild(this.tooltip);

          this.trigger.addEventListener('mouseenter', this.showTooltip.bind(this));
          this.trigger.addEventListener('mouseleave', this.hideTooltip.bind(this));
          this.trigger.addEventListener('focus', this.showTooltip.bind(this));
          this.trigger.addEventListener('blur', this.hideTooltip.bind(this));
        }
      }

      showTooltip() {
        this.loadImage();
        this.positionTooltip();
        this.tooltip.classList.add('is-visible');
        window.addEventListener('scroll', this.reposition, true);
        window.addEventListener('resize', this.reposition);
      }

      hideTooltip() {
        this.tooltip.classList.remove('is-visible');
        window.removeEventListener('scroll', this.reposition, true);
        window.removeEventListener('resize', this.reposition);
      }

      positionTooltip() {
        const rect = this.trigger.getBoundingClientRect();
        this.tooltip.style.top = `${rect.bottom + 12}px`;
        this.tooltip.style.left = `${rect.left}px`;
      }

      disconnectedCallback() {
        this.hideTooltip();
        this.tooltip?.remove();
      }

      loadImage() {
        if (this.loaded) return;
        this.loaded = true;

        const image = document.createElement('img');
        image.src = this.imageUrl;
        image.alt = this.getAttribute('data-product-energy-label-alt') || '';
        image.loading = 'lazy';
        this.tooltip.appendChild(image);
      }
    }
  );
}
